export const SIDEBAR_ACTIVE_MENUS = 'SIDEBAR_ACTIVE_MENUS'
export const SIDEBAR_VISIBLE = 'SIDEBAR_VISIBLE'
export const COLUMN_DEFS_PREFIX = 'COLUMN_DEFS_FOR_'
